export enum OrderPlacedBy {
	Admin = "Admin",
	B2c = "B2c",
	B2b = "B2b",
}
